// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./web/sass/mgm/asynchronous.scss
// module id = 1024
// module chunks = 89